import isEmpty from "lodash.isempty";
import { useMessageSource } from "react-message-source";
import * as Yup from "yup";

const IBAN_LENGTH = 21;

export function isValidSwissIban(input: string): boolean {
  if (!input) {
    return false;
  }

  // clean up the iban
  const iban = String(input)
    .toUpperCase()
    .replace(/[^A-Z0-9]/g, "");

  // check for valid length
  if (iban.length !== IBAN_LENGTH) {
    return false;
  }

  // split to country code, check digits and rest
  const code = iban.match(/^([A-Z]{2})(\d{2})([A-Z\d]+)$/);

  // the format is not iban, because the regex did not match
  if (!code) {
    return false;
  }

  // rearrange and replace letters to with digits
  const ibanDigits: string = (code[3] + code[1] + code[2]).replace(
    /[A-Z]/g,
    (letter) => `${letter.charCodeAt(0) - 55}`,
  );

  // calculate checksum
  let checksum: number = parseInt(ibanDigits.slice(0, 2), 10);
  let fragment;
  for (let offset = 2; offset < ibanDigits.length; offset += 7) {
    fragment = String(checksum) + ibanDigits.substring(offset, offset + 7);
    checksum = parseInt(fragment, 10) % 97;
  }

  // only 1 is a valid checksum
  return checksum === 1;
}

export function useIbanValidator(): Yup.StringSchema {
  const { getMessage } = useMessageSource();

  return Yup.string()
    .required(getMessage("Validation.message-required"))
    .test(
      "iban_validator",
      getMessage("Validation.message-invalidIban"),
      (value) => {
        return isValidSwissIban(value);
      },
    )
    .test(
      "bankName_validator",
      getMessage("Validation.message-invalidBankName"),
      function () {
        return !isEmpty(this.parent.bankName);
      },
    );
}
